/* ============================================================
   LUCE BRILLANTÉ — theme.js (v2)
   Header expand/collapse + menu, elongated hero, directory,
   4-per-slide shelves, SPA dedicated pages w/ staggered bands,
   cart, custom form, reveals.
   ============================================================ */
(function () {
  "use strict";
  /* stop the browser from restoring a previous scroll offset on reload —
     combined with initAnchorNav() below, a reload always lands at the top */
  if ("scrollRestoration" in history) { history.scrollRestoration = "manual"; }
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- self-serve checkout lock — flip to false to re-enable direct checkout ----------
     Adding to cart is fully live (clients build a selection normally). What's
     paused is Shopify's own self-serve payment page: any link or form that
     would send the browser to /checkout is intercepted and redirected to the
     cart's "Request Private Order & Consultation" flow instead, sitewide, no
     matter which template or button renders it. */
  var SELF_SERVE_CHECKOUT_BLOCKED = false;
  if (SELF_SERVE_CHECKOUT_BLOCKED) {
    function isCheckoutUrl(url){
      if (!url) return false;
      try { return new URL(url, window.location.origin).pathname.indexOf("/checkout") === 0; }
      catch (e) { return String(url).indexOf("/checkout") === 0; }
    }
    document.addEventListener("submit", function (e){
      var form = e.target;
      if (form && form.action && isCheckoutUrl(form.action)) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = "/cart#consult";
      }
    }, true);
    document.addEventListener("click", function (e){
      var a = e.target.closest && e.target.closest("a[href]");
      if (a && isCheckoutUrl(a.getAttribute("href"))) {
        e.preventDefault();
        window.location.href = "/cart#consult";
      }
    }, true);
  }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var M = {
    roundDiamond:'<svg viewBox="0 0 100 100" fill="none"><g data-stroke stroke="#C8D0DC" stroke-width="1.4"><polygon points="28,40 72,40 50,30"/><line x1="28" y1="40" x2="72" y2="40"/><polygon points="28,40 72,40 50,78"/><line x1="38" y1="40" x2="50" y2="78"/><line x1="62" y1="40" x2="50" y2="78"/><line x1="46" y1="40" x2="50" y2="78"/><line x1="54" y1="40" x2="50" y2="78"/><line x1="28" y1="40" x2="38" y2="30"/><line x1="72" y1="40" x2="62" y2="30"/><line x1="38" y1="30" x2="38" y2="40"/><line x1="62" y1="30" x2="62" y2="40"/></g></svg>',
    emeraldCut:'<svg viewBox="0 0 100 100" fill="none"><g data-stroke stroke="#C8D0DC" stroke-width="1.4"><polygon points="34,28 66,28 74,40 74,72 66,82 34,82 26,72 26,40"/><polygon points="40,38 60,38 64,44 64,68 60,74 40,74 36,68 36,44"/><line x1="34" y1="28" x2="40" y2="38"/><line x1="66" y1="28" x2="60" y2="38"/></g></svg>',
    solitaireRing:'<svg viewBox="0 0 100 100" fill="none"><g data-stroke stroke="#C8D0DC" stroke-width="1.4"><ellipse cx="50" cy="64" rx="26" ry="30"/><ellipse cx="50" cy="64" rx="20" ry="24" opacity="0.5"/><polygon points="42,30 58,30 50,22"/><polygon points="42,30 58,30 50,44"/><line x1="42" y1="30" x2="58" y2="30"/><line x1="46" y1="22" x2="46" y2="30"/><line x1="54" y1="22" x2="54" y2="30"/></g></svg>',
    pendant:'<svg viewBox="0 0 100 100" fill="none"><g data-stroke stroke="#C8D0DC" stroke-width="1.4"><path d="M16 26 Q50 58 84 26" opacity="0.55"/><circle cx="50" cy="52" r="4"/><polygon points="42,58 58,58 50,52"/><polygon points="42,58 58,58 50,84"/><line x1="42" y1="58" x2="58" y2="58"/></g></svg>',
    dropEarrings:'<svg viewBox="0 0 100 100" fill="none"><g data-stroke stroke="#C8D0DC" stroke-width="1.4"><path d="M34 30 a7 7 0 1 0 0.1 0" opacity="0.6"/><polygon points="28,46 40,46 34,40"/><polygon points="28,46 40,46 34,66"/><line x1="28" y1="46" x2="40" y2="46"/><path d="M66 30 a7 7 0 1 0 0.1 0" opacity="0.6"/><polygon points="60,46 72,46 66,40"/><polygon points="60,46 72,46 66,66"/><line x1="60" y1="46" x2="72" y2="46"/></g></svg>',
    tennisBracelet:'<svg viewBox="0 0 100 100" fill="none"><g data-stroke stroke="#C8D0DC" stroke-width="1.2"><path d="M14 54 Q50 70 86 54" opacity="0.4"/><rect x="22" y="48" width="9" height="9"/><rect x="35" y="46" width="9" height="9"/><rect x="48" y="45" width="9" height="9"/><rect x="61" y="46" width="9" height="9"/><rect x="74" y="48" width="9" height="9"/></g></svg>',
    bangle:'<svg viewBox="0 0 100 100" fill="none"><g data-stroke stroke="#C8D0DC" stroke-width="1.4"><ellipse cx="50" cy="52" rx="34" ry="30"/><ellipse cx="50" cy="52" rx="27" ry="23" opacity="0.45"/><rect x="46" y="20" width="8" height="8"/></g></svg>'
  };
  var byCat = { ring:['solitaireRing'], necklace:['pendant'], earrings:['dropEarrings'], bracelet:['tennisBracelet'], bangle:['bangle'] };
  var slideSet = {
    ring:['solitaireRing','roundDiamond','emeraldCut'],
    necklace:['pendant','roundDiamond','emeraldCut'],
    earrings:['dropEarrings','roundDiamond','solitaireRing'],
    bracelet:['tennisBracelet','roundDiamond','bangle'],
    bangle:['bangle','tennisBracelet','roundDiamond']
  };
  function groupOf(c){ return c === 'bangle' ? 'bracelet' : c; }

  var pieces = [
    ["Lumière Solitaire","Round brilliant, 2.1ct","ring"],["Éclat Pavé Band","Pavé eternity, 1.4ct","ring"],
    ["Aurore Trilogy","Three-stone oval, 3.0ct","ring"],["Aurora Drop Earrings","Pear pair, 3.2ct","earrings"],
    ["Rivière de Glace","Tennis riviera, 7.5ct","necklace"],["Clair de Lune","Emerald cut, 2.6ct","ring"],
    ["Cerchio Bangle","Channel-set, 2.9ct","bangle"],["Goccia Pendant","Briolette, 2.2ct","necklace"],
    ["Sérénité Halo","Cushion halo, 1.8ct","ring"],["Rivière Bracelet","Brilliant line, 5.0ct","bracelet"],
    ["Étoile Pendant","Round brilliant, 0.9ct","necklace"],["Fontana Chandelier","Marquise, 4.6ct","earrings"],
    ["Promesse Éternelle","Baguettes, 2.0ct","ring"],["Nastro Bracelet","Bezel link, 2.6ct","bracelet"],
    ["Reverie Marquise","Marquise, 2.4ct","ring"],["Cascata Lariat","Marquise drop, 1.3ct","necklace"],
    ["Éclat Studs","Brilliant studs, 2.0ct","earrings"],["Aureo Bangle","Pavé hinged, 3.1ct","bangle"],
    ["Voltaggio Signet","Princess, 1.2ct","ring"],["Collier de Lumière","Collar, 9.0ct","necklace"],
    ["Filo Bracelet","Single-thread, 1.5ct","bracelet"],["Rugiada Drops","Oval halo, 2.8ct","earrings"],
    ["Incanto Cathedral","Cathedral round, 2.2ct","ring"],["Mezzaluna Pendant","Half-moon, 1.4ct","necklace"],
    ["Serenata Tennis","Emerald line, 6.2ct","bracelet"],["Stella Climber","Emerald cut, 1.8ct","earrings"],
    ["Belle Époque","Cluster, 1.7ct","ring"],["Onda Bangle","Wave-set, 2.3ct","bangle"],
    ["Soluna Necklace","Y-drop, 2.0ct","necklace"],["Luce Hoops","Pavé hoops, 1.1ct","earrings"],
    ["Adagio Bypass","Twin-stone, 1.9ct","ring"],["Lumière Station","Bezel stations, 2.4ct","necklace"],
    ["Veluto Bolo","Bezel bolo, 1.6ct","bracelet"],["Prima Luce","Asscher, 2.5ct","ring"],
    ["Fiocco Studs","Cushion studs, 2.4ct","earrings"],["Notte Bangle","Bezel bangle, 2.7ct","bangle"],
    ["Aria Threader","Threader pair, 0.8ct","earrings"],["Lucente Bar","Baguette bar, 1.2ct","bracelet"],
    ["Clair Pendant","Pear brilliant, 1.6ct","necklace"],["Splendore Eternity","Full pavé, 2.3ct","ring"]
  ];
  var products = pieces.map(function (p, i) { return { id:i, name:p[0], desc:p[1], cat:p[2], group:groupOf(p[2]), price:"", motif:(byCat[p[2]]||['roundDiamond'])[0], slides:(slideSet[p[2]]||['roundDiamond','solitaireRing','emeraldCut']) }; });
  function find(id){ return products[id]; }
  function priceText(p){ return (p.price===""||p.price==null) ? "Price upon request" : "$"+Number(p.price).toLocaleString("en-US"); }

  /* ---------- card / frame builders ---------- */
  function slidesHTML(p){
    var s = p.slides && p.slides.length ? p.slides : [p.motif];
    var sl = s.map(function (m, k){ return '<div class="slide'+(k===0?' active':'')+'">'+M[m]+'</div>'; }).join("");
    var dt = s.length > 1 ? '<div class="dots">'+s.map(function (_, k){ return '<button class="dot'+(k===0?' active':'')+'" type="button" aria-label="Image '+(k+1)+'"></button>'; }).join("")+'</div>' : '';
    return '<div class="slides">'+sl+'</div>'+dt;
  }
  function cardHTML(p){
    return '<article class="card" data-group="'+p.group+'">'+
      '<div class="card__media">'+slidesHTML(p)+'</div>'+
      '<h3 class="card__name">'+p.name+'</h3><p class="card__desc">'+p.desc+'</p>'+
      '<div class="card__foot"><div class="card__price"><span class="k">Price</span><span class="v">'+priceText(p)+'</span></div>'+
      '<button class="card__add" data-add="'+p.id+'">Add to Cart</button></div></article>';
  }
  function frameHTML(p, top){
    return '<div class="frame" data-link="classics">'+
      (top ? '<span class="frame__badge">Maison</span>' : '')+
      '<div class="frame__pic"><div class="in">'+slidesHTML(p)+'</div>'+
      '<div class="frame__quick">Quick View &#9656;</div></div>'+
      '<div class="frame__name">'+p.name+'</div><div class="frame__price">'+priceText(p)+'</div></div>';
  }

  /* ---------- image carousel (hover-advance crossfade) ---------- */
  function initMedia(scope){
    $$(".slides", scope || document).forEach(function (s){
      if (s.dataset.wired) return; s.dataset.wired = "1";
      var slides = $$(".slide", s); if (slides.length < 2) return;
      var host = s.parentNode;                 /* .card__media or .in */
      var dots = $$(".dot", host);
      var prevBtn = $(".slide-arrow--prev", host), nextBtn = $(".slide-arrow--next", host);
      var i = 0, timer = null;
      function go(n){ i = (n + slides.length) % slides.length; slides.forEach(function (sl, k){ sl.classList.toggle("active", k===i); }); dots.forEach(function (d, k){ d.classList.toggle("active", k===i); }); }
      var card = s.closest(".card, .frame") || host;
      card.addEventListener("mouseenter", function (){ if (reduce) return; clearInterval(timer); go(i+1); timer = setInterval(function (){ go(i+1); }, 1600); });
      card.addEventListener("mouseleave", function (){ clearInterval(timer); go(0); });
      dots.forEach(function (d, k){ d.addEventListener("click", function (e){ e.preventDefault(); e.stopPropagation(); clearInterval(timer); go(k); }); });
      if (prevBtn) prevBtn.addEventListener("click", function (e){ e.preventDefault(); e.stopPropagation(); clearInterval(timer); go(i-1); });
      if (nextBtn) nextBtn.addEventListener("click", function (e){ e.preventDefault(); e.stopPropagation(); clearInterval(timer); go(i+1); });
      go(0);
    });
  }

  /* ---------- shelves (4 per slide, prev/next) ---------- */
  var shelfData = {
    classics: products,
    occasions: [3,0,7,9,16,4,29,12,8,19,34,1].map(find),
    atelier: [2,14,22,33,26,5,23,11,30,18,6,24].map(find)
  };
  function buildShelves(){
    $$(".shelf").forEach(function (sh){
      var track = $(".shelf__track", sh); if (!track) return;
      var total;
      if (track.children.length){ total = track.children.length; }   /* Shopify-rendered slides */
      else {
        var items = shelfData[sh.dataset.shelf] || products, perSlide = 4, slides = [];
        for (var i=0;i<items.length;i+=perSlide) slides.push(items.slice(i, i+perSlide));
        track.innerHTML = slides.map(function (grp, si){ return '<div class="shelf__slide">'+grp.map(function (p, j){ return frameHTML(p, si===0 && j===2); }).join("")+'</div>'; }).join("");
        total = slides.length;
      }
      var idx = 0, prev = $("[data-prev]", sh), next = $("[data-next]", sh);
      function upd(){ track.style.transform = "translateX("+(-idx*100)+"%)"; if (prev) prev.disabled = idx===0; if (next) next.disabled = idx>=total-1; }
      if (prev) prev.addEventListener("click", function (){ if (idx>0){ idx--; upd(); } });
      if (next) next.addEventListener("click", function (){ if (idx<total-1){ idx++; upd(); } });
      upd();
    });
  }

  /* ---------- dedicated pages (staggered bands) ---------- */
  function featureBand(side, motif, eyebrow, title, picks){
    var pairs = picks.map(cardHTML).join("");
    var feat = '<div class="band__feature">'+M[motif]+'<div class="band__cap"><span class="e">'+eyebrow+'</span><span class="t">'+title+'</span></div></div>';
    var pair = '<div class="band__pair">'+pairs+'</div>';
    return '<div class="band band--'+side+' reveal">'+(side==='l'?feat+pair:pair+feat)+'</div>';
  }
  function pageShell(eyebrow, title, intro, bandsHTML, extraHTML){
    return '<div class="page__hero"><div class="page__heroinner"><div class="emblem"></div>'+
      '<span class="page__eyebrow">'+eyebrow+'</span><h1 class="page__title">'+title+'</h1></div></div>'+
      (intro?'<p class="page__intro reveal">'+intro+'</p>':'')+
      '<div class="bands">'+bandsHTML+'</div>'+(extraHTML||'');
  }
  function buildClassicsPage(){
    var el = $("#pageClassics"); if (!el) return;
    var bands =
      featureBand('l','solitaireRing','The Ring','Brilliance, made to be worn',[find(0),find(8)])+
      featureBand('r','pendant','Necklaces & Pendants','Light, worn close',[find(4),find(7)])+
      featureBand('l','tennisBracelet','Bracelets','The line of light',[find(9),find(13)])+
      featureBand('r','dropEarrings','Earrings','An evening, transformed',[find(3),find(11)]);
    var grid = '<section class="section"><div class="section__head reveal"><div class="emblem"></div>'+
      '<span class="eyebrow">The Complete Collection</span><h2 class="section__title">Every Piece</h2>'+
      '<p class="section__intro">All forty creations, gathered by form.</p></div>'+
      '<div class="tabs reveal"><button class="tab active" data-filter="all">All</button>'+
      '<button class="tab" data-filter="ring">Rings</button><button class="tab" data-filter="necklace">Necklaces &amp; Pendants</button>'+
      '<button class="tab" data-filter="bracelet">Bracelets</button><button class="tab" data-filter="earrings">Earrings</button></div>'+
      '<div class="grid" id="fullGrid">'+products.map(cardHTML).join("")+'</div></section>';
    el.innerHTML = pageShell('The Collection','Timeless Classics',
      'Forty enduring expressions of the maison — presented first as a curated gallery, then in full below.', bands, grid);
    wireTabs($("#fullGrid"));
  }
  var occ = [
    { m:'pendant', t:'A New Light', e:'Childbirth', b:'To honour a life just begun — a quiet brilliance to be kept close now, and one day passed into smaller hands.', p:[10,38,8] },
    { m:'solitaireRing', t:'Years, Rendered in Light', e:'Anniversary', b:'For the milestones worth wearing — pieces that gather meaning with every passing year.', p:[0,1,12] },
    { m:'roundDiamond', t:'A Year More Radiant', e:'Birthday', b:'Mark another turn around the sun with a stone as singular as the day itself.', p:[16,29,34] },
    { m:'tennisBracelet', t:"The Season's Brilliance", e:'Seasonal Holidays', b:'Gifts for the season of gathering — wrapped in light and given with intention.', p:[9,4,19] }
  ];
  function buildOccasionsPage(){
    var el = $("#pageOccasions"); if (!el) return;
    var bands = occ.map(function (o, i){ return featureBand(i%2===0?'l':'r', o.m, o.e, o.t, [find(o.p[0]),find(o.p[1])]); }).join("");
    el.innerHTML = pageShell('Curated by Moment','Occasions',
      'For the moments that deserve to be remembered in something lasting.', bands, '');
  }
  function buildAtelierPage(){
    var el = $("#pageAtelier"); if (!el) return;
    var bands =
      featureBand('l','emeraldCut','The Hand','Drawn slowly, by hand',[find(33),find(22)])+
      featureBand('r','solitaireRing','The Stone','Chosen for its fire',[find(5),find(2)])+
      featureBand('l','pendant','The Commission','Yours, and yours alone',[find(7),find(23)]);
    var cta = '<section class="section section--tight" style="text-align:center;">'+
      '<div class="emblem"></div><span class="eyebrow">Bespoke</span>'+
      '<h2 class="section__title" style="margin:.6rem 0 1.4rem;">Begin a Commission</h2>'+
      '<p class="section__intro" style="margin-bottom:2.4rem;">Speak with our client advisors, who accompany every step from the first sketch to the setting of the final stone.</p>'+
      '<a class="submit" style="display:inline-block;width:auto;padding:1.1rem 3rem;" href="#home" data-link="home" data-target="#custom">Enquire with the Atelier</a></section>';
    el.innerHTML = pageShell('The Maison','The Atelier',
      'Where light is given permanent form — a private conversation between you and the bench.', bands, cta);
  }

  /* ---------- tabs filtering + sort/metal-filter controls ---------- */
  function wireTabs(grid){
    if (!grid) return;
    var section = grid.closest("section") || document;
    var tabs = $$(".tab[data-filter]", section);
    var metalChecks = $$('.grid-controls input[type="checkbox"]', section);
    var sortRadios = $$('.grid-controls input[type="radio"]', section);
    var originalOrder = $$(".card", grid);

    function staggerIn(){ $$(".card", grid).filter(function (c){ return c.style.display!=="none"; }).forEach(function (c, i){ c.style.transition="none"; c.style.opacity="0"; c.style.transform="translateY(20px)"; setTimeout(function (){ c.style.transition=""; c.style.opacity="1"; c.style.transform="none"; }, 40+i*22); }); }
    function activeTabFilter(){ var t = tabs.filter(function (x){ return x.classList.contains("active"); })[0]; return t ? t.dataset.filter : "all"; }
    function activeMetals(){ return metalChecks.filter(function (c){ return c.checked; }).map(function (c){ return c.value; }); }
    function activeSort(){ var r = sortRadios.filter(function (x){ return x.checked; })[0]; return r ? r.value : "recommended"; }

    function applyVisibility(){
      var cat = activeTabFilter(), metals = activeMetals();
      $$(".card", grid).forEach(function (c){
        var catOk = cat === "all" || c.dataset.group === cat;
        var metalOk = metals.length === 0 || metals.indexOf((c.dataset.metal || "").toLowerCase()) !== -1;
        c.style.display = (catOk && metalOk) ? "" : "none";
      });
    }
    function applySort(){
      var sort = activeSort(), list = originalOrder.slice();
      if (sort === "price-asc") list.sort(function (a, b){ return (+a.dataset.price || 0) - (+b.dataset.price || 0); });
      else if (sort === "price-desc") list.sort(function (a, b){ return (+b.dataset.price || 0) - (+a.dataset.price || 0); });
      list.forEach(function (c){ grid.appendChild(c); });
    }
    function refresh(withSort){
      grid.classList.add("fading");
      setTimeout(function (){ if (withSort) applySort(); applyVisibility(); grid.classList.remove("fading"); staggerIn(); }, 240);
    }

    tabs.forEach(function (t){ t.addEventListener("click", function (){
      tabs.forEach(function (x){ x.classList.remove("active"); }); t.classList.add("active");
      refresh(false);
    }); });
    metalChecks.forEach(function (c){ c.addEventListener("change", function (){ refresh(false); }); });
    sortRadios.forEach(function (r){ r.addEventListener("change", function (){ refresh(true); }); });
  }

  /* ---------- filter bar: Metal swatches / Price range / themed Sorting dropdown ---------- */
  function wireFilterBar(bar){
    if (!bar) return;
    var section = bar.closest("section") || document;
    var grid = $(".grid", section);
    if (!grid) return;
    var metalSwatches = $$("[data-filter-metal]", bar);
    var caratChips = $$("[data-filter-carat]", bar);
    var expandBtn = $("[data-grid-expand]", section);
    var originalOrder = $$(".card", grid);
    var sortValue = "recommended";

    /* price range slider */
    var priceMinInput = $("[data-price-min-input]", bar);
    var priceMaxInput = $("[data-price-max-input]", bar);
    var priceFill = $("[data-price-fill]", bar);
    var priceMinDisplay = $("[data-price-min-display]", bar);
    var priceMaxDisplay = $("[data-price-max-display]", bar);
    var priceMinTemplate = priceMinDisplay ? priceMinDisplay.textContent : "";
    var priceMaxTemplate = priceMaxDisplay ? priceMaxDisplay.textContent : "";
    function formatPrice(template, cents){
      var digits = Math.round(cents / 100).toLocaleString("en-US");
      return template.replace(/[\d,]+/, digits);
    }
    function updatePriceUI(){
      if (!priceMinInput || !priceMaxInput) return;
      var lo = +priceMinInput.min, hi = +priceMinInput.max;
      var a = +priceMinInput.value, b = +priceMaxInput.value;
      if (a > b){ var t = a; a = b; b = t; }
      var span = hi - lo || 1;
      if (priceFill){ priceFill.style.left = ((a - lo) / span * 100) + "%"; priceFill.style.width = ((b - a) / span * 100) + "%"; }
      if (priceMinDisplay) priceMinDisplay.textContent = formatPrice(priceMinTemplate, a);
      if (priceMaxDisplay) priceMaxDisplay.textContent = formatPrice(priceMaxTemplate, b);
    }
    updatePriceUI();

    /* themed sorting dropdown */
    var sortMenu = $("[data-sortmenu]", bar);
    var sortTrigger = $("[data-sortmenu-trigger]", bar);
    var sortPanel = $("[data-sortmenu-panel]", bar);
    var sortCurrent = $("[data-sortmenu-current]", bar);
    var sortOptions = $$(".sortmenu__option", bar);
    function closeSortMenu(){ if (sortMenu){ sortMenu.removeAttribute("data-open"); } if (sortTrigger) sortTrigger.setAttribute("aria-expanded", "false"); }
    if (sortTrigger) sortTrigger.addEventListener("click", function (e){
      e.stopPropagation();
      var open = !sortMenu.hasAttribute("data-open");
      closeSortMenu();
      if (open){ sortMenu.setAttribute("data-open", ""); sortTrigger.setAttribute("aria-expanded", "true"); }
    });
    document.addEventListener("click", function (e){ if (sortMenu && !sortMenu.contains(e.target)) closeSortMenu(); });
    sortOptions.forEach(function (opt){ opt.addEventListener("click", function (){
      sortOptions.forEach(function (o){ o.classList.remove("active"); }); opt.classList.add("active");
      sortValue = opt.dataset.sortValue;
      if (sortCurrent) sortCurrent.textContent = opt.textContent;
      closeSortMenu();
      refresh(true);
    }); });

    function staggerIn(){ $$(".card", grid).filter(function (c){ return c.style.display!=="none"; }).forEach(function (c, i){ c.style.transition="none"; c.style.opacity="0"; c.style.transform="translateY(20px)"; setTimeout(function (){ c.style.transition=""; c.style.opacity="1"; c.style.transform="none"; }, 40+i*22); }); }
    function activeMetals(){ return metalSwatches.filter(function (b){ return b.classList.contains("active"); }).map(function (b){ return b.dataset.filterMetal; }); }
    function activeCarats(){ return caratChips.filter(function (b){ return b.classList.contains("active"); }).map(function (b){ return b.dataset.filterCarat.split("-").map(Number); }); }

    function applyVisibility(){
      var metals = activeMetals();
      var carats = activeCarats();
      var priceLo = 0, priceHi = Infinity;
      if (priceMinInput && priceMaxInput){
        priceLo = Math.min(+priceMinInput.value, +priceMaxInput.value);
        priceHi = Math.max(+priceMinInput.value, +priceMaxInput.value);
      }
      $$(".card", grid).forEach(function (c){
        var metalOk = metals.length === 0 || metals.indexOf((c.dataset.metal || "").toLowerCase()) !== -1;
        var price = +c.dataset.price || 0;
        var priceOk = price === 0 || (price >= priceLo && price <= priceHi);
        var caratVal = +c.dataset.carat || 0;
        var caratOk = carats.length === 0 || (caratVal > 0 && carats.some(function (r){ return caratVal >= r[0] && caratVal < r[1]; }));
        c.style.display = (metalOk && priceOk && caratOk) ? "" : "none";
      });
    }
    function applySort(){
      var list = originalOrder.slice();
      if (sortValue === "price-asc") list.sort(function (a, b){ return (+a.dataset.price || 0) - (+b.dataset.price || 0); });
      else if (sortValue === "price-desc") list.sort(function (a, b){ return (+b.dataset.price || 0) - (+a.dataset.price || 0); });
      list.forEach(function (c){ grid.appendChild(c); });
    }
    function expandGrid(){
      if (grid.classList.contains("grid--limited")){
        grid.classList.remove("grid--limited");
        if (expandBtn) expandBtn.hidden = true;
      }
    }
    function refresh(withSort){
      expandGrid();
      grid.classList.add("fading");
      setTimeout(function (){ if (withSort) applySort(); applyVisibility(); grid.classList.remove("fading"); staggerIn(); }, 240);
    }

    metalSwatches.forEach(function (b){ b.addEventListener("click", function (){ b.classList.toggle("active"); refresh(false); }); });
    caratChips.forEach(function (b){ b.addEventListener("click", function (){ b.classList.toggle("active"); refresh(false); }); });
    if (priceMinInput && priceMaxInput){
      [priceMinInput, priceMaxInput].forEach(function (input){
        input.addEventListener("input", updatePriceUI);
        input.addEventListener("change", function (){ refresh(false); });
      });
    }
    if (expandBtn) expandBtn.addEventListener("click", function (){
      grid.classList.remove("grid--limited");
      expandBtn.hidden = true;
    });
  }

  /* ---------- themed <select> replacement (Category / Metal / Deposit Amount) ---------- */
  function wireThemedSelect(wrapper){
    if (!wrapper || wrapper.dataset.wired) return;
    var select = $(".themed-select__native", wrapper);
    if (!select) return;
    wrapper.dataset.wired = "1";

    var trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "themed-select__trigger";
    trigger.setAttribute("aria-expanded", "false");
    var current = document.createElement("span");
    current.className = "themed-select__current";
    trigger.appendChild(current);
    var chev = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    chev.setAttribute("viewBox", "0 0 10 6");
    chev.setAttribute("fill", "none");
    chev.setAttribute("aria-hidden", "true");
    chev.innerHTML = '<path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>';
    trigger.appendChild(chev);

    var panel = document.createElement("div");
    panel.className = "themed-select__panel";
    var optionEls = [];
    Array.prototype.forEach.call(select.options, function (opt){
      var b = document.createElement("button");
      b.type = "button";
      b.className = "themed-select__option";
      b.textContent = opt.textContent;
      if (opt.selected) b.classList.add("active");
      b.addEventListener("click", function (){
        select.value = opt.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        syncCurrent();
        optionEls.forEach(function (o){ o.classList.remove("active"); });
        b.classList.add("active");
        close();
      });
      optionEls.push(b);
      panel.appendChild(b);
    });

    function syncCurrent(){ var o = select.options[select.selectedIndex]; current.textContent = o ? o.textContent : ""; }
    syncCurrent();
    function close(){ wrapper.classList.remove("is-open"); trigger.setAttribute("aria-expanded", "false"); }
    trigger.addEventListener("click", function (e){
      e.stopPropagation();
      var open = !wrapper.classList.contains("is-open");
      $$(".themed-select.is-open").forEach(function (w){ w.classList.remove("is-open"); });
      if (open){ wrapper.classList.add("is-open"); trigger.setAttribute("aria-expanded", "true"); }
    });
    document.addEventListener("click", function (e){ if (!wrapper.contains(e.target)) close(); });

    wrapper.appendChild(trigger);
    wrapper.appendChild(panel);
    wrapper.classList.add("is-ready");
  }

  /* ---------- honeypot spam guard for contact forms ----------
     A hidden "website" field only a bot would fill in. If it has a value
     on submit, silently drop the submission instead of sending it. This is
     defense-in-depth alongside Shopify's own automatic reCAPTCHA v3 on the
     native contact form. */
  function guardHoneypotForms(){
    $$('form[action*="/contact"]').forEach(function (form){
      var trap = form.querySelector('[name="contact[website]"]');
      if (!trap || form.dataset.honeypotWired) return;
      form.dataset.honeypotWired = "1";
      form.addEventListener("submit", function (e){
        if (trap.value.trim() !== ""){ e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* ---------- reveals ---------- */
  var io = (!reduce && "IntersectionObserver" in window) ? new IntersectionObserver(function (es){ es.forEach(function (en){ if (en.isIntersecting){ en.target.classList.add("in-view"); io.unobserve(en.target); } }); }, { threshold:.12, rootMargin:"0px 0px -6% 0px" }) : null;
  function observeReveals(scope){ var els=$$(".reveal:not(.in-view)", scope||document); if (!io){ els.forEach(function (e){ e.classList.add("in-view"); }); return; } els.forEach(function (e){ io.observe(e); }); }

  /* ---------- header (expand / collapse / menu) ---------- */
  function initHeader(){
    var head = $("#head"); if (!head) return;
    var menu = $("#menu"), open = $("#menuOpen"), close = $("#menuClose"), scrim = $("#menuScrim");
    /* shared full-width mega menu for "Shop by Collection" / "Shop by Categories" / "Gifts" —
       one persistent panel; clicking a different tab swaps its content in place instead of
       moving or resizing the box. position:fixed + computed top so it isn't clipped by
       .head__expand's overflow:hidden, which it needs for its own collapse-on-scroll animation. */
    var mega = $("#megaMenu"), megaTriggers = $$(".head__drop-trigger", head);
    var megaPanels = mega ? $$(".mega__panel", mega) : [];
    function positionMega(){ if (mega) mega.style.top = Math.round(head.getBoundingClientRect().bottom) + "px"; }
    function closeMega(){
      if (!mega) return;
      mega.classList.remove("open");
      megaTriggers.forEach(function (t){ t.classList.remove("active"); t.setAttribute("aria-expanded", "false"); });
    }
    function openMega(key){
      if (!mega) return;
      positionMega();
      megaPanels.forEach(function (p){ p.classList.toggle("active", p.dataset.panel === key); });
      megaTriggers.forEach(function (t){
        var on = t.dataset.panel === key;
        t.classList.toggle("active", on);
        t.setAttribute("aria-expanded", on ? "true" : "false");
      });
      mega.classList.add("open");
    }
    if (mega && megaTriggers.length) {
      megaTriggers.forEach(function (trigger){
        trigger.addEventListener("click", function (e){
          e.stopPropagation();
          var key = trigger.dataset.panel;
          var isShowing = trigger.classList.contains("active") && mega.classList.contains("open");
          if (isShowing) closeMega(); else openMega(key);
        });
      });
      document.addEventListener("click", function (e){
        if (!e.target.closest(".head__drop-trigger") && !e.target.closest("#megaMenu")) closeMega();
      });
      document.addEventListener("keydown", function (e){ if (e.key === "Escape") closeMega(); });
      window.addEventListener("resize", function (){ if (mega.classList.contains("open")) positionMega(); });
    }
    /* dropdown previews swap to match whichever link is hovered/focused
       (e.g. bracelet photos while hovering "Bracelets & Bangles"); reverts
       to the default set when the pointer leaves the list. Shared by both
       the "Shop by Category" and "Shop by Collection" mega panels. */
    function wireDropPreview(list, preview){
      if (!list || !preview) return;
      var previewSets = $$(".mega__preview-set", preview);
      if (!previewSets.length) return;
      var defaultKey = previewSets[0].dataset.previewSet;
      function showPreview(key){
        previewSets.forEach(function (s){ s.classList.toggle("active", s.dataset.previewSet === key); });
      }
      $$("a[data-preview]", list).forEach(function (link){
        link.addEventListener("mouseenter", function (){ showPreview(link.dataset.preview); });
        link.addEventListener("focus", function (){ showPreview(link.dataset.preview); });
      });
      list.addEventListener("mouseleave", function (){ showPreview(defaultKey); });
    }
    wireDropPreview($(".mega__panel[data-panel='category'] .mega__list"), $("#categoryPreview"));
    wireDropPreview($(".mega__panel[data-panel='collection'] .mega__list"), $("#collectionPreview"));
    /* .page's padding-top must match the header's real height so page content
       never sits underneath the (opaque) fixed header — measured once while
       expanded, since that's the tallest state and the one every page loads
       into before the user has scrolled at all. */
    var expandedHeadHeight = head.getBoundingClientRect().height;
    document.documentElement.style.setProperty("--head-height", expandedHeadHeight + "px");
    function onScroll(){
      var nowCollapsed = window.scrollY > 30;
      if (nowCollapsed && !head.classList.contains("collapsed")) closeMega();
      head.classList.toggle("collapsed", nowCollapsed);
      document.documentElement.style.setProperty("--head-height", nowCollapsed ? "var(--head-collapsed)" : expandedHeadHeight + "px");
    }
    window.addEventListener("scroll", onScroll, { passive:true }); onScroll();
    window.addEventListener("resize", function (){
      if (!head.classList.contains("collapsed")) {
        expandedHeadHeight = head.getBoundingClientRect().height;
        document.documentElement.style.setProperty("--head-height", expandedHeadHeight + "px");
      }
    });
    function openMenu(){ if (menu){ menu.classList.add("open"); document.body.classList.add("no-scroll"); } if (scrim) scrim.classList.add("open"); }
    function closeMenu(){ if (menu){ menu.classList.remove("open"); document.body.classList.remove("no-scroll"); } if (scrim) scrim.classList.remove("open"); }
    if (open) open.addEventListener("click", openMenu);
    if (close) close.addEventListener("click", closeMenu);
    if (scrim) scrim.addEventListener("click", closeMenu);
    document.addEventListener("keydown", function (e){ if (e.key==="Escape") closeMenu(); });
    window.__lbCloseMenu = closeMenu;
    /* header search overlay */
    var searchPanel = $("#headSearch"), searchOpenBtn = $("#searchOpen"), searchCloseBtn = $("#searchClose"), searchInput = $("#headSearchInput");
    function openSearch(){
      if (!searchPanel) return;
      closeMega(); closeMenu();
      searchPanel.style.top = Math.round(head.getBoundingClientRect().bottom) + "px";
      searchPanel.classList.add("open");
      if (searchInput) setTimeout(function (){ searchInput.focus(); }, 260);
    }
    function closeSearch(){ if (searchPanel) searchPanel.classList.remove("open"); }
    if (searchOpenBtn) searchOpenBtn.addEventListener("click", function (e){
      e.stopPropagation();
      if (searchPanel && searchPanel.classList.contains("open")) closeSearch(); else openSearch();
    });
    if (searchCloseBtn) searchCloseBtn.addEventListener("click", closeSearch);
    document.addEventListener("keydown", function (e){ if (e.key === "Escape") closeSearch(); });
    document.addEventListener("click", function (e){
      if (!e.target.closest("#headSearch") && !e.target.closest("#searchOpen")) closeSearch();
    });
    window.addEventListener("resize", function (){ if (searchPanel && searchPanel.classList.contains("open")) searchPanel.style.top = Math.round(head.getBoundingClientRect().bottom) + "px"; });
    /* drawer accordions — Shop by Collection / Shop by Category / Gifts expand-in-place,
       any number can be open at once; clicking empty space in the menu collapses whichever are open */
    var accs = $$(".menu__acc", menu);
    if (accs.length) {
      function closeAllAccs(except){
        accs.forEach(function (a){
          if (a === except) return;
          a.classList.remove("open");
          var t = $(".menu__acc-toggle", a); if (t) t.setAttribute("aria-expanded", "false");
        });
      }
      accs.forEach(function (acc){
        var toggle = $(".menu__acc-toggle", acc);
        if (!toggle) return;
        toggle.addEventListener("click", function (e){
          e.stopPropagation();
          var willOpen = !acc.classList.contains("open");
          acc.classList.toggle("open", willOpen);
          toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
        });
      });
      if (menu) menu.addEventListener("click", function (e){
        if (!e.target.closest(".menu__acc-toggle") && !e.target.closest("a")) closeAllAccs();
      });
    }
  }

  /* ---------- hero ---------- */
  function initHero(){
    var cards = $$(".hero__card"); if (!cards.length) return;
    if (reduce){ cards.forEach(function (c){ c.classList.add("in"); }); return; }
    requestAnimationFrame(function (){ setTimeout(function (){ cards.forEach(function (c){ c.classList.add("in"); }); }, 200); });
  }

  /* ---------- same-page anchor links (Discover the Collection, etc.) ---------- */
  function initAnchorNav(){
    /* scroll smoothly but never leave "#section" sitting in the address bar —
       otherwise reloading the page reloads straight into that section instead
       of the hero at the top */
    document.addEventListener("click", function (e){
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute("href").slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? "auto" : "smooth" });
      history.replaceState(null, "", location.pathname + location.search);
    });
    /* a page loaded with a "#section" in the URL — either a genuine link to
       that section (e.g. the header's Gifts link, which points to /#gifts
       so it works from any page) or a stale hash left over from an earlier
       visit/reload. If the target exists, honor it once, then still strip
       the hash from the address bar so a later reload opens at the top. */
    if (location.hash){
      var targetId = location.hash.slice(1);
      var target = targetId ? document.getElementById(targetId) : null;
      history.replaceState(null, "", location.pathname + location.search);
      if (target) {
        requestAnimationFrame(function (){ target.scrollIntoView({ behavior: "auto" }); });
      } else {
        window.scrollTo(0, 0);
      }
    }
  }

  /* ---------- scroll restore on back/forward navigation ----------
     history.scrollRestoration is set to "manual" above (so a plain reload
     always lands at the top); this restores the *browser back button* case
     specifically — landing back on a collection/home page at roughly the
     scroll depth the visitor left it at, instead of the top, so they don't
     have to re-scroll to find the product they were just looking at. */
  function initScrollRestore(){
    var key = "lb_scrollY:" + location.pathname + location.search;
    var saveTimer = null;
    function save(){ try { sessionStorage.setItem(key, String(window.scrollY)); } catch (e) {} }
    window.addEventListener("scroll", function (){
      if (saveTimer) return;
      saveTimer = setTimeout(function (){ saveTimer = null; save(); }, 150);
    }, { passive: true });
    window.addEventListener("pagehide", save);

    function restore(){
      var saved;
      try { saved = sessionStorage.getItem(key); } catch (e) { saved = null; }
      if (saved === null) return;
      var y = parseInt(saved, 10);
      if (!y) return;
      /* strip any "#section" from the URL so initAnchorNav's own
         scrollIntoView doesn't fight this restore on the way back to a
         collection/home page that was left mid-scroll with a hash in the bar */
      if (location.hash) { history.replaceState(null, "", location.pathname + location.search); }
      /* keep re-applying until the page's height stops changing (lazy images
         and reveal-in cards can still be settling layout after load),
         instead of guessing at a fixed number of retries */
      window.scrollTo(0, y);
      var stopped = false, settleTimer = null, hardStop = null, ro = null;
      function stop(){
        if (stopped) return;
        stopped = true;
        if (ro) ro.disconnect();
        if (settleTimer) clearTimeout(settleTimer);
        if (hardStop) clearTimeout(hardStop);
      }
      function schedule(){
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(stop, 400);
      }
      if (window.ResizeObserver) {
        ro = new ResizeObserver(function (){ window.scrollTo(0, y); schedule(); });
        ro.observe(document.body);
      }
      schedule();
      hardStop = setTimeout(stop, 3000);
    }

    /* two distinct ways a "back" navigation can land here, and both need
       handling separately:
       1) a real reload — DOMContentLoaded fires normally, and the
          Navigation Timing entry says "back_forward".
       2) an instant back-forward-cache (bfcache) restore — the page is
          resurrected from an in-memory snapshot with no reload at all, so
          DOMContentLoaded never fires again; only "pageshow" does, with
          event.persisted === true. Because scrollRestoration is set to
          "manual" above, the browser won't restore scroll on its own here
          either, so without this branch a bfcache back-navigation (by far
          the most common case on mobile Safari and modern desktop Chrome)
          would silently land at the top every time. */
    var navEntries = window.performance && performance.getEntriesByType ? performance.getEntriesByType("navigation") : [];
    var navType = navEntries && navEntries[0] ? navEntries[0].type : null;
    if (navType === "back_forward") restore();
    window.addEventListener("pageshow", function (e){ if (e.persisted) restore(); });
  }

  /* ---------- router ---------- */
  function initRouter(){
    var views = $$(".view");
    if (!views.length) return;   /* Shopify single-page: use native anchor scrolling, not SPA routing */
    var titles = { home:"Luce Brillanté", classics:"Timeless Classics — Luce Brillanté", occasions:"Occasions — Luce Brillanté", atelier:"The Atelier — Luce Brillanté" };
    function show(view, target){
      if (!titles[view]) view = "home";
      views.forEach(function (v){ v.hidden = (v.dataset.view !== view); });
      document.title = titles[view];
      $$("[data-link]").forEach(function (a){ a.classList && a.classList.toggle("active", a.dataset.link===view); });
      $$(".head__nav a, .menu__nav a").forEach(function (a){ a.classList.toggle("active", a.dataset.link===view); });
      window.scrollTo(0,0);
      var active = views.filter(function (v){ return v.dataset.view===view; })[0];
      requestAnimationFrame(function (){ observeReveals(active); if (target){ var t=$(target); if (t) setTimeout(function (){ t.scrollIntoView({behavior: reduce?"auto":"smooth"}); }, 120); } });
    }
    function route(){ show((location.hash||"#home").replace("#","")); }
    document.addEventListener("click", function (e){
      var a = e.target.closest && e.target.closest("[data-link]"); if (!a) return;
      e.preventDefault();
      var view = a.dataset.link, target = a.dataset.target || null;
      if (window.__lbCloseMenu) window.__lbCloseMenu();
      if (location.hash.replace("#","")===view){ show(view, target); }
      else { history.pushState(null,"","#"+view); show(view, target); }
    });
    window.addEventListener("popstate", route);
    window.addEventListener("hashchange", route);
    route();
  }

  /* ---------- cart ---------- */
  function initCart(){
    var cart=[], el=$("#cart"), scrim=$("#scrim"), items=$("#cartItems"), count=$("#cartCount"), sub=$("#cartSubtotal"), cta=$("#cartCta"), foot=$("#cartFoot");
    if (!el) return;
    function qty(id){ var r=cart.filter(function (c){ return c.id===id; })[0]; return r?r.qty:0; }
    function open(){ el.classList.add("open"); scrim.classList.add("open"); document.body.classList.add("no-scroll"); }
    function close(){ el.classList.remove("open"); scrim.classList.remove("open"); el.classList.remove("checkout-mode"); document.body.classList.remove("no-scroll"); }
    function add(id){ var r=cart.filter(function (c){ return c.id===id; })[0]; if (r) r.qty++; else cart.push({id:id,qty:1}); render(); open(); }
    function setQty(id,q){ cart=cart.map(function (c){ return c.id===id?{id:id,qty:q}:c; }).filter(function (c){ return c.qty>0; }); render(); }
    function render(){
      if (count) count.textContent = cart.reduce(function (s,c){ return s+c.qty; },0);
      if (!cart.length){ items.innerHTML='<div class="cart__empty"><span class="lg">Your selection is empty</span>Add pieces to begin a private enquiry.</div>'; if (foot) foot.style.display="none"; return; }
      if (foot) foot.style.display="block";
      items.innerHTML = cart.map(function (c){ var p=find(c.id); return '<div class="line"><div class="line__thumb">'+M[p.motif]+'</div><div><h3 class="line__name">'+p.name+'</h3><p class="line__desc">'+p.desc+'</p><div class="qty"><button data-dec="'+c.id+'">&#8722;</button><span>'+c.qty+'</span><button data-inc="'+c.id+'">+</button></div></div><div class="line__right"><span class="line__price">'+priceText(p)+'</span><button class="line__rm" data-rm="'+c.id+'">Remove</button></div></div>'; }).join("");
      sub.textContent="Upon request"; cta.textContent="Request to Purchase";
    }
    items.addEventListener("click", function (e){ var t=e.target; if (t.dataset.inc!=null) setQty(+t.dataset.inc, qty(+t.dataset.inc)+1); else if (t.dataset.dec!=null) setQty(+t.dataset.dec, qty(+t.dataset.dec)-1); else if (t.dataset.rm!=null) setQty(+t.dataset.rm,0); });
    document.addEventListener("click", function (e){ var b=e.target.closest&&e.target.closest("[data-add]"); if (!b) return; add(+b.dataset.add); b.classList.add("is-added"); var o=b.textContent; b.textContent="Added \u2713"; setTimeout(function (){ b.textContent=o; b.classList.remove("is-added"); },1200); });
    var bar=$("#cartbar"); if (bar) bar.addEventListener("click", function (e){ e.preventDefault(); open(); });
    var cl=$("#cartClose"); if (cl) cl.addEventListener("click", close);
    if (scrim) scrim.addEventListener("click", close);
    document.addEventListener("keydown", function (e){ if (e.key==="Escape") close(); });
    if (cta) cta.addEventListener("click", function (){ el.classList.add("checkout-mode"); });
    var back=$("#checkoutBack"); if (back) back.addEventListener("click", function (){ el.classList.remove("checkout-mode"); });
    var sbtn=$("#ckSubmit"); if (sbtn) sbtn.addEventListener("click", function (){ var nm=$("#ckName").value.trim(), em=$("#ckEmail").value.trim(); if (!nm||!em){ (nm?$("#ckEmail"):$("#ckName")).focus(); return; } $("#checkoutForm").hidden=true; $("#checkoutDone").hidden=false; cart=[]; render(); });
    render();
  }

  /* ---------- toast ---------- */
  var toastTimer = null;
  function showToast(message){
    var el = $("#toast");
    if (!el) {
      el = document.createElement("div");
      el.id = "toast";
      el.className = "toast";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function (){ el.classList.remove("show"); }, 6000);
  }
  window.__lbShowToast = showToast;

  /* ---------- private-order consultation panel (cart page) ---------- */
  function initCartConsult(initialHash){
    var openBtn = $("#consultOpen"), panel = $("#consultPanel"), head = $("#head");
    if (!openBtn || !panel) return;
    function scrollToPanel(smooth){
      var headH = head ? head.getBoundingClientRect().height : 84;
      var y = panel.getBoundingClientRect().top + window.pageYOffset - headH - 16;
      window.scrollTo({ top: Math.max(y, 0), behavior: smooth ? "smooth" : "auto" });
    }
    openBtn.addEventListener("click", function (){
      var willOpen = !panel.classList.contains("open");
      panel.classList.toggle("open", willOpen);
      if (willOpen) {
        setTimeout(function (){ scrollToPanel(!reduce); }, 60);
        var first = $("#ciName"); if (first) setTimeout(function (){ first.focus(); }, 450);
      }
    });
    if (initialHash === "#consult") {
      panel.classList.add("open");
      setTimeout(function (){ scrollToPanel(false); }, 60);
    }
  }

  /* ---------- custom form ---------- */
  function initCustom(){
    var b=$("#cSubmit"); if (!b) return;
    b.addEventListener("click", function (){ var nm=$("#cName").value.trim(), em=$("#cEmail").value.trim(); if (!nm||!em){ (nm?$("#cEmail"):$("#cName")).focus(); return; } $("#customForm").hidden=true; $("#customDone").hidden=false; });
  }

  function hydrateArt(){ $$("[data-m]").forEach(function (el){ if (!el.children.length && M[el.dataset.m]) el.innerHTML = M[el.dataset.m]; }); }

  document.addEventListener("DOMContentLoaded", function (){
    var initialHash = location.hash;
    hydrateArt();
    buildClassicsPage(); buildOccasionsPage(); buildAtelierPage();
    buildShelves();
    $$(".grid").forEach(function (g){ if (g.id === "fullGrid") return; var sec = g.closest("section"); if (sec && (sec.querySelector(".tab[data-filter]") || sec.querySelector("[data-grid-controls]"))) wireTabs(g); });
    $$("[data-filterbar]").forEach(wireFilterBar);
    $$("[data-themed-select]").forEach(wireThemedSelect);
    guardHoneypotForms();
    initScrollRestore();
    initAnchorNav();
    initHeader(); initHero(); initCart(); initCartConsult(initialHash); initCustom();
    initMedia(document);
    initRouter();
    observeReveals(document);
  });
})();

(function () {
  var RATE_KEY = "lbFxCadUsd";
  var RATE_TTL = 6 * 60 * 60 * 1000; // 6h
  var MODE_KEY = "lbCurrency";
  var rate = null;

  function getCachedRate() {
    try {
      var raw = localStorage.getItem(RATE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || typeof obj.r !== "number" || Date.now() - obj.t > RATE_TTL) return null;
      return obj.r;
    } catch (e) { return null; }
  }

  function setCachedRate(r) {
    try { localStorage.setItem(RATE_KEY, JSON.stringify({ r: r, t: Date.now() })); } catch (e) {}
  }

  function fetchRate(cb) {
    var cached = getCachedRate();
    if (cached) { rate = cached; cb(cached); return; }
    if (!window.fetch) { cb(null); return; }
    fetch("https://open.er-api.com/v6/latest/CAD")
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var r = data && data.rates && data.rates.USD;
        if (typeof r === "number") { rate = r; setCachedRate(r); cb(r); } else { cb(null); }
      })
      .catch(function () { cb(null); });
  }

  function applyMode(mode) {
    document.querySelectorAll("[data-price-cad]").forEach(function (el) {
      if (!el.dataset.origText) el.dataset.origText = el.textContent;
      var cad = parseFloat(el.getAttribute("data-price-cad"));
      if (isNaN(cad)) return;
      if (mode === "USD" && rate) {
        var usd = cad * rate;
        el.textContent = "$" + usd.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " USD (est.)";
      } else {
        el.textContent = el.dataset.origText;
      }
    });
    document.querySelectorAll("[data-currency-disclaimer]").forEach(function (el) {
      el.style.display = (mode === "USD" && rate) ? "" : "none";
    });
  }

  function initCurrencyToggle() {
    var btn = document.getElementById("currencyToggle");
    if (!btn) return;
    var mode = localStorage.getItem(MODE_KEY) || "CAD";

    function render() {
      btn.textContent = mode === "USD" ? "USD (est.)" : "CAD";
      btn.setAttribute("aria-pressed", mode === "USD" ? "true" : "false");
    }

    function activate() {
      render();
      if (mode === "USD") {
        fetchRate(function () { applyMode("USD"); });
      } else {
        applyMode("CAD");
      }
    }

    btn.addEventListener("click", function () {
      mode = mode === "CAD" ? "USD" : "CAD";
      try { localStorage.setItem(MODE_KEY, mode); } catch (e) {}
      activate();
    });

    activate();
  }

  document.addEventListener("DOMContentLoaded", initCurrencyToggle);
})();

(function () {
  var KEY = "lbFavorites";

  function getFavorites() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function setFavorites(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function isFavorited(handle) {
    return getFavorites().indexOf(handle) !== -1;
  }

  function toggleFavorite(handle) {
    var list = getFavorites();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    setFavorites(list);
    syncUI();
    return list.indexOf(handle) !== -1;
  }

  function syncUI() {
    var list = getFavorites();
    document.querySelectorAll("[data-favorite-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-handle");
      var on = list.indexOf(handle) !== -1;
      btn.classList.toggle("is-favorited", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      var label = btn.querySelector("[data-favorite-label]");
      if (label) { label.textContent = on ? "Saved to Favorites" : "Save to Favorites"; }
    });
    var countEl = document.getElementById("favoritesCount");
    if (countEl) {
      if (list.length > 0) { countEl.textContent = list.length; countEl.style.display = ""; }
      else { countEl.style.display = "none"; }
    }
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-favorite-toggle]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute("data-handle");
    if (!handle) return;
    toggleFavorite(handle);
  });

  document.addEventListener("DOMContentLoaded", syncUI);
  window.__lbFavorites = { get: getFavorites, isFavorited: isFavorited, toggle: toggleFavorite };
})();
